<template lang="pug">
  div
    page-preloader
    div.map-container.navigation-control.routes
      div.toolbar.toolbar--bordered
        div.line
          h1.title Карта
      div.new-map
        div(ref="map" v-once)#map.bigmap
        transition(name="slide-fade")
          div(
            v-if="openedRoute && openedRoute.id"
            :style="{width: '537px !important'}"
          ).legend.map-routes.cuscroll.open
            div
              div.head
                h2.title Изменение маршрута
                div.legend-info
                span.legend__close(@click="closeRoute()")
              
              div.type-group
                div.route-info
                  div.route-info-line.flex-col
                    label Номер маршрута
                    input(v-model="openedRoute.name" type="text")
              
              div.type-group
                div.route-info
                  div.route-info-line
                    label Протяженность (км):
                    span {{openedRoute.distance}}
                  div.route-info-line
                    label Приблизительное время:
                    span {{openedRoute.duration}}
                  div.route-info-line
                    label Стоимость:
                    span {{openedRoute.cost}}
                  div.route-info-line
                    label(
                      style="margin-right: 2%"
                    ) Масса:
                    input.radio(
                      value="5"
                      v-model="openedRoute.mass"
                      name="mass"
                    )
              
              div.type-group
                div.route-info.schedule
                  div.route-info-line
                    label Периодичность маршрута
                  
                  div.route-info-line.flex
                    .route-info-line__block
                      e-radio(
                        name="period_id"
                        :options="routePeriods"
                        :model="openedRoute"
                        tabView="tab1"
                      ).periodicity
                    .route-info-line__block
                      template(v-if="openedRoute.period_id === PERIOD_WEEKLY")
                        div.week
                          p День недели
                          label.radioButton
                            input.radio(
                              value="1"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Пн
                          label.radioButton
                            input.radio(
                              value="2"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Вт
                          label.radioButton
                            input.radio(
                              value="3"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Ср
                        div.week
                          label.radioButton
                            input.radio(
                              value="4"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Чт
                          label.radioButton
                            input.radio(
                              value="5"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Пт
                          label.radioButton
                            input.radio(
                              value="6"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Сб
                        div.week
                          label.radioButton
                            input.radio(
                              value="7"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Вс
              
              div(style="margin: 0.7rem").type-group.type-group--small-pad
                div.col
                  e-form(:formValidator="formValidator")
                    .start-point(
                      v-for="(copyPoint, index) in copyPoints"
                      :key="index"
                    )
                      e-form-group(
                        formGroupStyle="col-block mt-4"
                        :inputStyle="{width: index > 0 ? '86%' : '94%', 'margin-top': '3%', display: 'inline-block'}"
                        name="start_point_address"
                        inputType="address"
                        :label="`Начальная точка №${index + 1}`"
                        :model="copyPoint"
                        tabView="tab1"
                        :required="true"
                        :addressData="addressData"
                        addressProvider="dadata"
                        @selectItem="data => onSelectCopyAddress(data, index)"
                      )
                        template(v-slot:buttons_panel)
                          button(
                            :style="{'margin-left': '3%'}"
                            v-show="index > 0"
                            @click="removeCopyPoint(index)"
                          ).actions-panel__button.btn-delete.btn-red.small
                    div(
                      :style="{'margin-top': '4%'}"
                    )
                      button(
                        @click.stop.prevent="addCopyPoint"
                        title="Добавить начальную точку"
                      ).actions-panel__button.btn-add.btn-green.small
                    e-form-group(
                      style="margin-top: 4%"
                      name="end_point_id"
                      :inputStyle="{width: '94%', 'margin-top': '3%', display: 'inline-block'}"
                      inputType="select"
                      label="Место размещения отхода"
                      :model="openedRoute"
                      tabView="tab1"
                      :required="true"
                      :options="tkoObjects"
                      @change="onChangeAddressTkoObject"
                    )
                  div.control-panel
                    div(v-if="isCalcEnabled")
                      button(@click.stop.prevent="calcRoute").actions-panel__button.btn-calc.btn-blue.small
                      span Рассчитать маршрут
                    div(v-if="!saving && isSaveEnabled")
                      button(
                        @click.stop.prevent="saveRoute"
                        :disabled="saving"
                      ).actions-panel__button.btn-save.btn-blue.small
                      span Сохранить
                    div(v-else-if="saving")
                      button(@click.stop.prevent="").actions-panel__button.btn-refresh.btn-btn-yellow.small
                      span Сохранение...
             
              div.type-group.type-group--noborder.route-table
                table
                  thead
                    th
                    th №
                    th Адрес
                  tbody
                    tr(
                      v-for="(point, index) in copyPoints"
                      :key="index"
                      class="hovered"
                      title="Начальная точка - гараж"
                      @click="zoomToPoint(point)"
                    )
                      td
                        img(:src="GarageImage" style="width:20px")
                      td {{index + 1}}
                      td {{point.start_point_address}}
                    tr(
                      class="hovered"
                      title="Конечная точка - объект размещения отходов"
                      @click="zoomToPoint(endPoint)"
                    )
                      td
                        img(:src="OROImage" style="width:20px")
                      td -
                      td {{endPoint.address}}
          div(
            v-else
            key="routes"
          ).legend.map-routes.cuscroll.open
            div
              div.head
                h2.title Маршруты
                div.legend-info
                span
              
              div.type-group.type-group--small-pad
              div(@click.stop.prevent="addRoute()").add-address
                button.actions-panel__button.btn-add.btn-green.small
                span Добавить маршрут
              div(@click.stop.prevent="removeAllRoutes()").add-address
                button.actions-panel__button.btn-delete.btn-red.small
                span Удалить все
              
              e-perfect-scrollbar(ref="routes")
                div.type-group.type-group--noborder.route
                  table
                    thead
                      th № Маршрута
                      th Периодичность
                      th Протяженность (км)
                      th
                    tbody(
                      is="transition-group"
                      name="flip-list"
                      v-if="routes.length > 0"
                    )
                      tr(
                        :key="route.id"
                        v-for="route in routes"
                        @click="openRoute(route.id)"
                      )
                        td {{route.name ? route.name : ''}}
                        td {{route.period ? route.period.name : ''}}
                        td {{route.distance}}
                        td
                          span(
                            @click.stop.prevent="removeRoute(route.id)"
                          ).close--small
                    tbody(v-else)
                      tr
                        td(colspan=100) нет маршрутов
            
            div.type-group.type-group--noborder.route-create
              button(
                v-if="SHOW_HIDDEN_FIELDS"
                @click.stop.prevent="removeAll()"
              ).route-create__button Удалить все
              button(
                @click.stop.prevent="$refs.autoRoute.open()"
              ).route-create__button Автосоставление маршрутов

</template>


<script>
  import 'leaflet'
  import { MAP, TILE_LAYER } from '@/config/map'
  import { POLYGON } from '@/config/polygon'
  import mapMixin from '../../mixins/map-mixin.js'
  import { map as mapEndpoints, transport } from '../../api/api-endpoints.js'
  import { PERIOD_WEEKLY_ID, SHOW_HIDDEN_FIELDS, STATUS_ACTIVE, WALL } from '@/config/config'
  import userFriendlyEr from '../../utils/userFriendlyEr.js'
  import RoutesDrawer from './utils/RoutesDrawer'
  import autoRoute from './components/auto-route'
  import Route from './models/Route'
  import GarageImage from '../../assets/img/pins/mps.png'
  import OROImage from '../../assets/img/pins/oro.png'
  import formBaseMixin from '../../components/form/form-base-mixin.js'
  import { core } from '@/api/api-endpoints'
  
  export default {
    name: 'RoutesFromSettlements',
    data() {
      this.mapLayers = null
      this.map = null
      return {
        saving: false,
        calcEnable: false,
        addressData: {},
        copyPoints: [{ id: null, coords: [], address: '', start_point_address: '', data: null }],
        openedRoute: {
          cost: 0,
          mass: 0,
          start_point_address: '',
          startPoint: {
            id: null,
            coords: [],
            address: '',
            data: null
          },
          endPoint: {
            id: null,
            coords: [],
            address: '',
            data: null
          }
        },
        routeMsns: {}
      }
    },
    components: {
      autoRoute
    },
    mixins: [mapMixin, formBaseMixin],
    computed: {
      collections() {
        return this.$store.getters.readUrlEndpoint(
          this.getCollectionEndpoint()
        ) || {}
      },
      conditions() {
        return {
          noStartPoint: !!(!this.startPoint?.coords?.[0] && !this.endPoint?.coords?.[0]),
          onlyStartPoint: !!(this.startPoint?.coords?.[0] && !this.endPoint?.coords?.[0]),
          onlyStartAndEndPoints: !!(this.startPoint?.coords?.[0] && this.endPoint?.coords?.[0]),
        }
      },
      endPoint() {
        return this.openedRoute?.endPoint ?? {
          id: null,
          coords: [],
          address: '',
          data: null
        }
      },
      startPoint() {
        return this.copyPoints?.[0]?.startPoint ?? {
          id: null,
          coords: [],
          address: '',
          data: null
        }
      },
      routePointList() {
        return Object.values(this.routeMsns)
      },
      isCalcEnabled() {
        let c = this.conditions
        return c.onlyStartAndEndPoints
      },
      isSaveEnabled() {
        return this.isCalcEnabled
      },
      SHOW_HIDDEN_FIELDS() {
        return SHOW_HIDDEN_FIELDS
      },
      GarageImage() {
        return GarageImage
      },
      OROImage() {
        return OROImage
      },
      /**
       * @return {number}
       */
      PERIOD_WEEKLY() {
        return PERIOD_WEEKLY_ID
      },
      PERIODS() {
        return PERIODS
      },
      routePeriods() {
        return this.collections.route_period
      },
      weekDays() {
        return this.collections.weekday
      },
      STATUS_ACTIVE() {
        return STATUS_ACTIVE
      },
      mapBorders() {
        return this.$store.getters.readUrlEndpoint(
          mapEndpoints.heatMapRegOperators(this.$route.query.zoom || MAP.zoom)
        )
      },
      routes() {
        return this.$store.getters.readUrlEndpoint(this.getRoutesEndpoint())?.data || []
      },
      tkoObjects() {
        return this.$store.getters.readUrlEndpoint(this.getTKOObjects())?.data || []
      }
    },
    destroyed() {
      this.markerClickSubs.unsubscribe()
    },
    methods: {
      removeCopyPoint(index) {
        this.copyPoints.splice(index, 1)
      },
      getCollectionEndpoint() {
        return core.collection('route_period,weekday')
      },
      onSelectCopyAddress({ data, value }, index) {
        const newValue = {
          ...this.copyPoints[index],
          originId: this.openedRoute.id,
          start_point_address: value,
          startPoint: {
            coords: [+data.geo_lat, +data.geo_lon],
            data
          }
        }
        
        this.$set(this.copyPoints, index, newValue)
      },
      onChangeAddressTkoObject() {
        this.tkoObjects.forEach(item => {
          if (item.id === this.openedRoute.end_point_id) {
            this.openedRoute.endPoint = {
              id: item.id,
              address: item.name,
              coords: [
                +item.latitude,
                +item.longitude
              ]
            }
            this.openedRoute.endAddress = `${item.name}, ${item.address}`
            if (!this.startPoint.coords?.[0]) {
              this.showMsg('Выберите начальную точку маршрута', 'success', 90000)
            }
          }
        })
      },
      calcRoute() {
        this.reCalcRoute()
      },
      zoomToPoint(point) {
        const { latitude, longitude, coords } = point
        if (latitude && longitude) {
          this.map.setView([latitude, longitude], 16)
        } else if (Array.isArray(coords)) {
          this.map.setView(coords, 16)
        }
      },
      scrollToBottom() {
        if (this.$refs.routes) {
          this.$refs.routes.setScrollTop(999999)
        } else if (this.$refs.points) {
          this.$refs.points.setScrollTop(999999)
        }
      },
      async routesGenerated() {
        this.$bar.start()
        this.$refs.autoRoute.freeze()
        await this.batchCreateRoute().then(async () => {
          await this.fetchData().then(() => {
            this.scrollToBottom()
            this.showOnSuccess('Новые маршруты сформированы')
          })
        }).catch(e => {
          console.error(e)
          this.onError(e)
        }).finally(() => {
          this.$bar.finish()
          this.$refs.autoRoute.close()
        })
      },
      async batchCreateRoute() {
        let lastNumber = this.getNextRouteNumber()
        for (let i = 0; i < this.copyPoints.length; i++) {
          let data = await this.directions(this.copyPoints[i])
          data.name = `${lastNumber}`
          await this.$store.dispatch('createModel', { url: transport.route(), data })
          lastNumber++
        }
        return true
      },
      removeRoute(id) {
        this.confirmBox(
          'Удаленный маршрут нельзя будет восстановить',
          'Удалить маршрут?'
        ).then(() => {
          this.$bar.start()
          this.$store.dispatch('deleteModel', {
            url: transport.route(id)
          }).then(() => {
            this.showOnSuccess('Маршрут удален')
            this.fetchData()
          }).catch(e => {
            console.error(e)
            this.onError(e)
          }).finally(() => {
            this.$bar.finish()
          })
        })
      },
      confirmBox(
        msg = 'Удаленную запись нельзя будет восстановить',
        title = 'Удалить запись?',
        confirmBtnText = 'Удалить'
      ) {
        return this.$confirm(msg, title, {
          confirmButtonText: confirmBtnText,
          cancelButtonText: 'Отмена',
          type: 'warning',
          closeOnClickModal: false
        })
      },
      
      async saveRoute() {
        if (this.saving) {
          return
        }
        this.$bar.start()
        this.saving = true
        try {
          const data = this.openedRoute
          await this.$store.dispatch('updateModel', {
            url: transport.route(this.openedRoute.id),
            data
          })
          const [, points] = this.copyPoints
          await this.batchCreateRoutesFromPoints(points)
          
          const message = this.copyPoints.length > 1 ? 'Маршруты сохранены' : 'Маршрут сохранен'
          
          this.showOnSuccess(message)
          this.fetchData()
          
          this.saving = false
          this.$bar.finish()
        } catch (e) {
          console.error(e)
          this.onError(e)
        }
      },
      async batchCreateRoutesFromPoints(points) {
        if (points.length) {
          for (const copyData of points) {
            await this.$store.dispatch('createModel', {
              url: transport.route(),
              data: { ...data, ...copyData, id: null }
            })
          }
        }
      },
      async reCalcRoute() {
        this.showWarning('Подождите, маршрут рассчитывается.')
        this.$bar.start()
        this.routesDrawer.removeRoute()
        if (this.copyPoints.length) {
          for (let i = 0; i < this.copyPoints.length; i++) {
            let copyRoute = await this.directions({ ...this.openedRoute, ...this.copyPoints[i] })
            this.$set(this.copyPoints, i, { ...this.copyPoints[i], ...copyRoute, id: null })
            await this.routesDrawer.drawRoute(copyRoute)
          }
        }
        let route = await this.directions(this.openedRoute)
        
        if (Object.keys(route).length) {
          this.saveEnable = this.isSaveEnabled
          this.openedRoute = Object.assign({}, this.openedRoute, route)
          await this.routesDrawer.drawRoute(this.openedRoute)
          this.$bar.finish()
          this.showOnSuccess('Маршрут рассчитан.')
        } else {
          this.onError('Расчет не удался из-за ошибки. Попробуйте еще раз')
          this.calcEnable = true
        }
      },
      async directions(inputOpenedRoute = {}) {
        let openedRoute = JSON.parse(JSON.stringify(inputOpenedRoute))
        let latlngArr = Object.values(this.routeMsns).map(v => `${v.latitude || v.lat},${v.longitude || v.lng}`)
        let startPointCoords = openedRoute?.startPoint?.coords || []
        let endPointCoords = openedRoute?.endPoint?.coords || []
        
        let query = {}
        query = {
          origin: `${startPointCoords[0]},${startPointCoords[1]}`,
          destination: `${endPointCoords[0]},${endPointCoords[1]}`
        }
        const queryString = []
        let ws = latlngArr.slice()
        query.waypoints = ws.join(';')
        if (query.origin) {
          queryString.push(query.origin)
        }
        if (query.waypoints && query.waypoints.length > 0) {
          queryString.push(query.waypoints)
        }
        if (query.destination) {
          queryString.push(query.destination)
        }
        
        await this.$store.dispatch('createModel', {
          url: transport.directions,
          data: { coords: queryString.join(';') }
        }).then(({ data = {} }) => {
          if (!data?.routes) {
            return
          }
          let polyline = []
          let distance = data.distance
          let duration = data.duration
          // create route
          
          data.routes.legs.forEach(leg => {
            distance = distance + (+leg.distance)
            duration = duration + (+leg.duration)
            leg.steps.forEach(step => {
              let decoded = step.geometry.coordinates
              decoded.forEach(point => polyline.push(point))
            })
          })
          openedRoute.polyline = polyline
          if (distance > 0) {
            openedRoute.distance = (distance / 1000).toFixed(3)
          }
          if (duration > 0) {
            let hours = Math.floor(duration / 60 / 60)
            let durInMin = Math.round((duration / 60) - (60 * hours))
            openedRoute.durationInSec = duration
            openedRoute.duration = `${hours} ч, ${durInMin} мин`
          }
          
        }).catch(e => {
          console.error(e)
          return Promise.reject(e)
        })
        return openedRoute
      },
      showMsg(message, type = 'success', duration = WALL.SUCCESS_TIMEOUT) {
        this.msgSuccess = this.$message({ message, type, duration })
      },
      onError(e) {
        this.$message({
          message: userFriendlyEr.recognize(e),
          type: 'error',
          duration: WALL.ERROR_TIMEOUT
        })
      },
      showOnSuccess(title = 'Действие успешно завершено') {
        this.$swal({
          position: 'center',
          type: 'success',
          title: title,
          showConfirmButton: false,
          timer: WALL.SUCCESS_TIMEOUT
        })
      },
      showWarning(title = 'Пожалуйста, подождите!') {
        this.$swal({
          position: 'center',
          type: 'warning',
          title: title,
          showConfirmButton: false,
          timer: WALL.SUCCESS_TIMEOUT
        })
      },
      addCopyPoint() {
        this.copyPoints.push({ id: null, coords: [], address: '', data: null, start_point_address: '' })
      },
      async openRoute(id) {
        if (!this.routes.length) {
          return
        }
        
        this.$store.commit('preloaderOn', true)
        this.$store.commit('preloader', true)
        
        this.saveEnable = false
        this.$bar.start()
        
        if (this.routes.length) {
          const foundRoute = this.routes.find(r => r.id === id)
          
          this.openedRoute = Object.assign({}, this.openedRoute, foundRoute)
          setTimeout(async () => {
            this.routesDrawer.removeRoute()
            await this.routesDrawer.drawRoute(this.openedRoute)
            this.prevPostiton = {
              zoom: this.map.getZoom(),
              center: this.map.getCenter()
            }
            this.routesDrawer.zoomToRoute()
            this.$store.commit('preloaderOn', false)
            this.$store.commit('preloader', false)
          }, 500)
          this.$bar.finish()
        }
        if (this.conditions.noStartPoint) {
          this.showMsg('Выберите начальную точку маршрута')
        }
      },
      closeRoute() {
        if (this.prevPostiton && this.prevPostiton.zoom) {
          this.map.setView(
            this.prevPostiton.center,
            this.prevPostiton.zoom
          )
        }
        this.openedRoute = Object.create(null)
        this.routesDrawer.removeAll()
        this.fetchData()
      },
      getNextRouteNumber() {
        let biggest = 0
        if (this.routes.length) {
          biggest = 1
          this.routes.forEach(v => {
            if (v.name && +v.name > 0) {
              biggest = +v.name
            }
          })
        }
        return biggest + 1
      },
      // create new route
      addRoute() {
        this.$bar.start()
        let route = new Route()
        route.name = this.getNextRouteNumber()
        this.$store.dispatch('createModel', {
          url: transport.route(),
          data: route
        }).then(r => {
          let { data: { id } } = r
          this.fetchData().then(() => {
            this.scrollToBottom()
            setTimeout(() => {
              this.openRoute(id)
            }, 500)
          })
        }).catch(e => {
          console.error(e)
          this.onError(e)
        }).finally(() => {
          this.$bar.finish()
        })
      },
      prepareMSNModel(model) {
        let containersVolumeSum = 0
        if (!model.hasOwnProperty('containers_count') && model.daily_norm) {
          model.containers_count = Math.round(model.daily_norm)
        }
        
        if (model.volume_count) {
          containersVolumeSum = (model.volume_count * 1).toFixed(3)
        } else if (model.containers_count) {
          containersVolumeSum = (model.containers_count * 0.75).toFixed(3)
        }
        if (isNaN(containersVolumeSum)) {
          containersVolumeSum = 0
        }
        model = { ...model, containersVolumeSum }
        return model
      },
      getMapConfig(key) {
        return MAP[key]
      },
      getMapPolygon() {
        return POLYGON
      },
      drawTiles() {
        L.tileLayer(TILE_LAYER, {}).addTo(this.map)
      },
      afterMapInit() {
        this.routesDrawer = new RoutesDrawer(this.map, this)
        this.map.on('click', (e) => {
          if (this.openedRoute && this.openedRoute.id && this.saveEnable === false) {
            this.showStartPointMap(e)
          }
        })
      },
      showStartPointMap(e) {
        const coords = this.openedRoute.startPoint.coords.filter(c => c)
        if (coords.length === 0) {
          this.openedRoute.startPoint = { ...this.openedRoute.startPoint, coords: [+e.latlng.lat, +e.latlng.lng] }
          this.openedRoute.start_point_address = '-'
          this.routesDrawer.drawStartPoint(this.openedRoute)
        } else {
          const point = {
            start_point_address: '-',
            startPoint: {
              coords: [+e.latlng.lat, +e.latlng.lng]
            }
          }
          this.copyPoints.push(point)
          this.routesDrawer.drawStartPoint(point)
        }
      },
      /* required for use in map-poup.vue */
      popupIsOpened(markerInfo) {
        return false
      },
      /* required for use in map-poup.vue */
      registerOpenPopup(markerInfo) {
      },
      destroyMap() {
        console.log('destroyed')
        this.$emitter.emit('geo.destroyMap', {})
        // this.map.remove()
        this.map = null
      },
      getRoutesEndpoint() {
        return transport.routes({
          query: {
            'per-page': -1
          }
        })
      },
      getTKOObjects() {
        return mapEndpoints.tkoObjects({
          query: { 'per-page': -1 }
        })
      },
      removeAllRoutes: async function() {
        this.$bar.start()
        try {
          if (this.routes.length) {
            for (let i = 0; i < this.routes.length; i++) {
              await this.$store.dispatch('deleteModel', {
                url: transport.route(this.routes[i].id),
                data: this.routes[i]
              })
            }
            await this.fetchData()
          }
          this.showOnSuccess('Маршруты удалены')
        } catch (e) {
          console.error(e)
          alert(e.toString())
        } finally {
          this.$bar.finish()
        }
      },
      fetchData() {
        let { asyncData } = this.$options
        this.$bar.start()
        return asyncData({
          store: this.$store,
          route: this.$route,
          methods: this
        }).catch(e => {
          console.error(e)
        }).finally(() => {
          this.$bar.finish()
        })
      }
    },
    asyncData({ store, route, fromRoute, methods }) {
      const endpoints = {
        cache: [
          methods.getCollectionEndpoint(),
          mapEndpoints.heatMapRegOperators(route.query.zoom || MAP.zoom),
          methods.getTKOObjects()
        ],
        noncache: [
          methods.getRoutesEndpoint()
        ]
      }
      
      function collectPromises({ cache = [], noncache = [] }) {
        return [
          cache.map(endpoint => store.dispatch('updateUrlEndpoint', { endpoint, fromCache: true })),
          noncache.map(endpoint => store.dispatch('updateUrlEndpoint', { endpoint }))
        ].flat()
      }
      
      let promises = collectPromises(endpoints)
      
      if (!promises.length) {
        return Promise.resolve(1)
      }
      
      return Promise.all(promises)
    }
  }
</script>

<style type="scss" scoped>
  .control-panel {
    display: flex;
    margin-bottom: 15px;
    margin-top: 4%
  }
  
  .control-panel > div:nth-child(2) {
    margin-left: 12%;
  }
  
  .leaflet-routing-container {
    display: none;
  }
  
  .hovered:hover {
    cursor: pointer;
  }
  
  .route-table table {
    padding: 1px !important;
    height: 20vh;
    overflow-y: auto;
    width: 100%;
    display: block;
  }
  
  .main-layout .legend .head:hover {
    cursor: default;
  }
  
  .mt-4 {
    margin-top: 4%;
  }

</style>
